import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
        <div className="container text-center">
            <h4 className="mb-4">Contáctanos</h4>
            <div className="social-icons mb-4">
                <a href="https://www.instagram.com/lumiere_tica/" className="text-white mx-3" rel="noopener noreferrer"><i className="fab fa-instagram fa-2x"></i></a>
                <a href="https://www.facebook.com/share/14ix2eKhsKE/" className="text-white mx-3" rel="noopener noreferrer"><i className="fab fa-facebook fa-2x"></i></a>
            </div>
            <p className="mb-0">© {new Date().getFullYear()} Lumiere Tica. Todos los derechos reservados</p>
        </div>
    </footer>
    );
};

export default Footer;